import { FolderSimple, DownloadSimple, ShareNetwork, PencilSimple, ArrowsOutSimple, Trash, Square, CheckSquare } from "@phosphor-icons/react";
import { fileIcon, fmtBytes, fmtRelDate } from "./util.jsx";
import { RowMenu } from "./widgets.jsx";

export default function ListView({
  contents, selectedFiles, selectedFolders,
  onToggleFile, onToggleFolder, onOpenFolder,
  onFileAction, onFolderAction,
}) {
  return (
    <div className="border border-black/10 rounded-md overflow-hidden" data-testid="list-view">
      <div className="hidden md:grid grid-cols-[36px_1fr_120px_160px_140px_40px] gap-3 px-3 py-2 border-b border-black/10 bg-black/[0.02] text-[11px] uppercase tracking-widest text-black/55">
        <span></span>
        <span>Name</span>
        <span>Size</span>
        <span>Uploaded by</span>
        <span>Modified</span>
        <span></span>
      </div>
      <ul className="divide-y divide-black/10">
        {contents.folders.map((d) => (
          <FolderRow
            key={d.id} d={d}
            selected={selectedFolders.has(d.id)}
            onToggle={() => onToggleFolder(d.id)}
            onOpen={() => onOpenFolder(d.id)}
            onAction={onFolderAction}
          />
        ))}
        {contents.items.map((f) => (
          <FileRow
            key={f.id} f={f}
            selected={selectedFiles.has(f.id)}
            onToggle={() => onToggleFile(f.id)}
            onAction={onFileAction}
          />
        ))}
      </ul>
    </div>
  );
}

function FolderRow({ d, selected, onToggle, onOpen, onAction }) {
  return (
    <li className={`grid grid-cols-[36px_1fr_120px_160px_140px_40px] gap-3 px-3 py-2.5 items-center hover:bg-black/[0.03] ${selected ? "bg-[#FF3366]/5" : ""}`} data-testid={`folder-row-${d.id}`}>
      <button onClick={onToggle} className="text-black/55 hover:text-black" data-testid={`sel-folder-${d.id}`}>
        {selected ? <CheckSquare size={18} weight="fill" className="text-[#FF3366]"/> : <Square size={18}/>}
      </button>
      <button onClick={onOpen} className="flex items-center gap-3 min-w-0 text-left" data-testid={`open-folder-${d.id}`}>
        <FolderSimple size={20} weight="fill" className="text-[#FFA000] shrink-0"/>
        <span className="truncate font-medium">{d.name}</span>
      </button>
      <span className="text-sm text-black/55">—</span>
      <span className="text-sm text-black/70 truncate">—</span>
      <span className="text-xs font-mono text-black/55">{fmtRelDate(d.created_at)}</span>
      <RowMenu testid={`folder-menu-${d.id}`} items={[
        { label: "Rename", icon: <PencilSimple size={14}/>, onClick: () => onAction("rename", d) },
        { label: "Move to…", icon: <ArrowsOutSimple size={14}/>, onClick: () => onAction("move", d) },
        { label: "Delete", icon: <Trash size={14}/>, onClick: () => onAction("delete", d), danger: true },
      ]}/>
    </li>
  );
}

function FileRow({ f, selected, onToggle, onAction }) {
  return (
    <li className={`grid grid-cols-[36px_1fr_120px_160px_140px_40px] gap-3 px-3 py-2.5 items-center hover:bg-black/[0.03] ${selected ? "bg-[#FF3366]/5" : ""}`} data-testid={`file-row-${f.id}`}>
      <button onClick={onToggle} className="text-black/55 hover:text-black" data-testid={`sel-file-${f.id}`}>
        {selected ? <CheckSquare size={18} weight="fill" className="text-[#FF3366]"/> : <Square size={18}/>}
      </button>
      <div className="flex items-center gap-3 min-w-0">
        {fileIcon(f.filename, f.content_type, 20)}
        <span className="truncate font-medium">{f.filename}</span>
      </div>
      <span className="text-sm font-mono text-black/65">{fmtBytes(f.size)}</span>
      <span className="text-sm text-black/70 truncate">{f.uploaded_by || "—"}</span>
      <span className="text-xs font-mono text-black/55">{fmtRelDate(f.created_at)}</span>
      <RowMenu testid={`file-menu-${f.id}`} items={[
        { label: "Download", icon: <DownloadSimple size={14}/>, onClick: () => onAction("download", f) },
        { label: "Share link", icon: <ShareNetwork size={14}/>, onClick: () => onAction("share", f) },
        { label: "Rename", icon: <PencilSimple size={14}/>, onClick: () => onAction("rename", f) },
        { label: "Move to…", icon: <ArrowsOutSimple size={14}/>, onClick: () => onAction("move", f) },
        { label: "Delete", icon: <Trash size={14}/>, onClick: () => onAction("delete", f), danger: true },
      ]}/>
    </li>
  );
}
